import { render } from "./AppLogo.vue?vue&type=template&id=7d8bc7b9"
const script = {}

import "./AppLogo.vue?vue&type=style&index=0&id=7d8bc7b9&lang=css"

import exportComponent from "/home/forge/s.thebuyhive.com/expertsourcing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__